var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class Trans {
    /** Add or modify translations map */
    static populateTranslations({ language, translations, }) {
        // XXX: Possibly should consider doing `Trans.markdown` in `by` functions to optimize for speed?
        translations.forEach((v) => {
            const txt = v[language];
            if (!txt) {
                if (v.KEY) {
                    Trans.translations.set(v.KEY, Trans.markdown(v.EN));
                }
                return;
            }
            Trans.translations.set(v.EN, Trans.markdown(txt));
            if (v.KEY) {
                Trans.translations.set(v.KEY, Trans.markdown(txt));
            }
        });
        Trans.isPopulated = true;
    }
    /** Translate the value first try `key`, then by `en`, if all empty return en. */
    static by(en, key) {
        var _a;
        let found;
        if (key) {
            found = Trans.translations.get(key);
        }
        const result = (_a = found !== null && found !== void 0 ? found : Trans.translations.get(en)) !== null && _a !== void 0 ? _a : en;
        return Trans.markdown(result);
    }
    static translationIsReady() {
        return __awaiter(this, void 0, void 0, function* () {
            return Trans.isPopulatedPromis;
        });
    }
    static waitForPopulateTranslation() {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: WINDOW check is needed for server side rendering, but not sure if this is the best way to do it
            const window = globalThis;
            if (!window.document) {
                return false;
            }
            const maxTries = 300;
            let i = 0;
            return new Promise((res) => {
                const interval = setInterval(() => {
                    if (!Trans.isPopulated && i <= maxTries) {
                        i += 1;
                        return;
                    }
                    clearInterval(interval);
                    res(i < maxTries);
                }, 100);
            });
        });
    }
    /** Translate a string in english */
    static byValue(en) {
        var _a;
        return (_a = Trans.translations.get(en)) !== null && _a !== void 0 ? _a : en;
    }
    /** Translated strictly by the key value */
    static byKey(key) {
        var _a;
        return (_a = Trans.translations.get(key)) !== null && _a !== void 0 ? _a : key;
    }
    static hasKey(key) {
        return !!Trans.translations.get(key);
    }
    static byKeyOrDefault({ key, defaultKey }) {
        return Trans.hasKey(key) ? Trans.byKey(key) : Trans.byKey(defaultKey);
    }
    static markdown(txt) {
        if (!txt) {
            return '';
        }
        // Clear XSS
        const inputP = document.createElement('p');
        inputP.innerText = txt;
        const userInput = inputP.innerText;
        const parsedValue = userInput
            .replace(/^### (.*$)/gim, '<h3>$1</h3>')
            .replace(/^## (.*$)/gim, '<h2>$1</h2>')
            .replace(/^# (.*$)/gim, '<h1>$1</h1>')
            .replace(/^> (.*$)/gim, '<blockquote>$1</blockquote>')
            .replace(/\*\*(.*)\*\*/gim, '<b>$1</b>')
            .replace(/\*(.*)\*/gim, '<i>$1</i>')
            .replace(/!\[(.*?)\]\((\/.*?)\)/gim, "<img alt='$1' src='$2' />")
            .replace(/\[(.*?)\]\((\/.*?)\)/gim, "<a href='$2'>$1</a>")
            .replace(/#br#/g, '<br />');
        return parsedValue;
    }
}
Trans.isPopulatedPromis = Trans.waitForPopulateTranslation();
/** Map from `TranslationLanguage` value or `KEY` value to the current language text. */
Trans.translations = new Map();
export default Trans;
